import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// 检查是否存在 Vue 应用的挂载点
const container = document.querySelector('#app-layout')

// 只有当挂载点存在时才初始化 Vue 应用
if (container) {
  // 如果已有实例，先卸载
  if (container.__vue_app__) {
    container.__vue_app__.unmount()
  }

  const app = createApp(App).use(router)
  app.mount('#app-layout')
}
